import { useFormik } from "formik";
import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";
import { useHistory, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { Col, Container, Form, FormFeedback, Input, Row } from "reactstrap";
import { OrganisationService } from "src/services/OrganisationService";
import * as Yup from "yup";

const service = new OrganisationService();

export const CreateOrganisation = () => {
  const history = useHistory();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      phone: "",
      address: "",
      city: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter organization name"),
    }),
    onSubmit: (values: any) => {
      console.log(values);
      service.createOrganisation(values)
        .then(function (response) {
          history.push("/organisations");
          toast.success(`You have created a new organization: ${values.name}!`);
        })
        .catch(function (error) {
          console.log("API ERROR");
          console.log(error);
          toast.error("Failed to create organization. Please try again.");
        });
    }
  });

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div style={{ paddingTop: 10, paddingBottom: 20, display: "flex", flexDirection: "row" }}>
              <Link style={{ color: "black" }}
                to="/organisations"
                className="nav_link"
              >
                <h5>Organizations</h5>
              </Link>
              <i className="bi bi-chevron-right"></i>
              <h5 style={{ marginLeft: 13, opacity: 0.6 }}>Create organization</h5>
            </div>
          </div>
        </div>

        <div>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Container fluid className="p-5">

              {/* Name */}
              <Row>
                <Col lg={4} md={5} className="col-xxl-1 p-2">
                  <h5>Name:</h5>
                </Col>
                <Col lg={4} md={5} className="col-xxl-11">
                  <Input
                    id="name"
                    name="name"
                    className="form-control"
                    placeholder="Enter organization name"
                    type="text"
                    onChange={validation.handleChange}
                    value={validation.values.name}
                    invalid={validation.touched.name && !!validation.errors.name}
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid"><>{validation.errors.name}</></FormFeedback>
                  ) : null}
                </Col>
              </Row>

              {/* Phone */}
              <Row>
                <Col lg={4} md={5} className="col-xxl-1 p-2">
                  <h5>Phone:</h5>
                </Col>
                <Col lg={4} md={5} className="col-xxl-11">
                  <Input
                    id="phone"
                    name="phone"
                    className="form-control"
                    placeholder="Enter phone number"
                    type="text"
                    onChange={validation.handleChange}
                    value={validation.values.phone}
                  />
                </Col>
              </Row>

              {/* Address */}
              <Row>
                <Col lg={4} md={5} className="col-xxl-1 p-2">
                  <h5>Address:</h5>
                </Col>
                <Col lg={4} md={5} className="col-xxl-11">
                  <Input
                    id="address"
                    name="address"
                    className="form-control"
                    placeholder="Enter address"
                    type="text"
                    onChange={validation.handleChange}
                    value={validation.values.address}
                  />
                </Col>
              </Row>

              {/* City */}
              <Row>
                <Col lg={4} md={5} className="col-xxl-1 p-2">
                  <h5>City:</h5>
                </Col>
                <Col lg={4} md={5} className="col-xxl-11">
                  <Input
                    id="city"
                    name="city"
                    className="form-control"
                    placeholder="Enter city"
                    type="text"
                    onChange={validation.handleChange}
                    value={validation.values.city}
                  />
                </Col>
              </Row>

            </Container>

            <Container fluid>
              <div className="d-flex flex-row-reverse">
                <div className="p-1">
                  <button
                    className="btn btn-primary btn-block"
                    style={{ border: 0, backgroundColor: "#95CBB2", color: "#FFFFFF" }}
                    type="submit"
                  >
                    Save
                  </button>
                </div>
                <div className="p-1">
                  <Link
                    className="btn btn-secondary btn-block"
                    to="/organisations"
                  >
                    Cancel
                  </Link>
                </div>
              </div>
            </Container>
          </Form>
        </div>
      </div>
    </React.Fragment>
  );
};

CreateOrganisation.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withTranslation()(withRouter(CreateOrganisation));
